/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-restricted-imports */

import { AnyAction, combineReducers, Reducer } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

import { api } from 'app/app.api';
import { analyticsReducer as analytics } from 'app/views/layout/views/analytics/analytics.reducer';
import { conversationsReducer as conversationsPage } from 'app/views/layout/views/conversations/conversations.reducer';
import { dashboardReducer as dashboard } from 'app/views/layout/views/dashboard/dashboard.reducer';
import { searchReducer as search } from 'app/views/layout/views/search/search.reducer';
import { messengerSettingsReducer as messengerSettings } from 'app/views/layout/views/settings/views/messenger/views/messengerSettings/messengerSettings.reducer';
import { activityLogReducer as activityLog } from 'components/activityLog/reducers/activityLog';
import { elevioReducer as elevio } from 'components/conversation/components/integrations/elevio/src';
import { knowledgeReducer as knowledge } from 'components/conversation/components/integrations/knowledge/knowledge.reducer';
import conversation from 'components/conversation/reducers/conversation';
import conversations from 'components/conversation/reducers/conversations';
import emailMessages from 'components/conversation/reducers/emailMessage';
import offers from 'components/conversation/reducers/offers';
import originalEmail from 'components/conversation/reducers/originalEmail';
import timeline from 'components/conversation/reducers/timeline';
import typing from 'components/conversation/reducers/typing';
import errors from 'components/errors/reducers/errors';
import notifications from 'components/notifications/reducers/notification';
import holdMusic from 'components/powerCallFlow/components/modals/holdMusic/reducers/holdMusic';
import waitMusic from 'components/powerCallFlow/components/modals/waitMusic/reducers/waitMusic';
import { callFlow } from 'components/powerCallFlow/reducers/callFlow';
import callFlows from 'components/powerCallFlow/reducers/callFlows';
import flowLanguages from 'components/powerCallFlow/reducers/flowLanguages';
import { nodes } from 'components/powerCallFlow/reducers/nodes';
import chatFlow from 'components/powerChatFlow/reducers/chatFlow';
import chatFlows from 'components/powerChatFlow/reducers/chatFlows';
import chatNodes from 'components/powerChatFlow/reducers/chatNodes';
import nodeWidgetCustomization from 'components/powerChatFlow/reducers/nodes/widgetCustomization';
import emailFlow from 'components/powerEmailFlow/reducers/emailFlow';
import presence from 'components/presence/reducers/presence';
import settings from 'components/settings/reducers/settings';
import addCaller from 'components/shared/addCallerModal/reducers/addCaller';
import attachmentsPreviewModal from 'components/shared/attachmentsPreviewModal/reducers/attachmentsPreviewModal';
import audio from 'components/shared/audio/reducers/audio';
import companyModal from 'components/shared/companyModal/reducers/companyModal';
import composeEmail from 'components/shared/composeEmail/reducers/composeEmail';
import confirmModal from 'components/shared/confirmModal/reducers/confirmModal';
import transferToAgent from 'components/shared/transferToAgentModal/reducers/transferToAgentModal';
import transferToNumber from 'components/shared/transferToNumberModal/reducers/transferToNumberModal';
import { transferToQueue } from 'components/shared/transferToQueueModal/reducers/transferToQueueModal';
import team from 'components/teamPageLegacy/reducers/team';
import telephony from 'components/telephony/reducers/telephony';
import { userModalReducer as userModal } from 'components/usersModal';
import { widgetReducer as widget } from 'components/widget';
import { electronReducer as electron } from 'middleware/electron';
import { jabraReducer as jabra } from 'middleware/jabra';
import { syncActions } from 'middleware/sync';
import { twilio } from 'middleware/twilio/reducers/twilio';
import { visibility } from 'middleware/visibility/reducers/visibility';
import { websocketReducer as websocket } from 'middleware/websocket/reducers/websocket';

import { appReducer as app } from './app/app.reducer';
import { elevioApiReducers } from './assets/components/conversation/components/integrations/elevio/src/utils/apis/elevioApi';
import { presenceOverlayReducer as presenceOverlay } from './store/slices/presenceOverlay.slice';

/** Creates the top-level reducer. */
export const createReducer = () => {
  const reducer = combineReducers({
    [api.reducerPath]: api.reducer,
    activityLog,
    addCaller,
    analytics,
    app,
    attachmentsPreviewModal,
    audio,
    callFlow,
    callFlows,
    chatFlow,
    chatFlows,
    chatNodes,
    companyModal,
    composeEmail,
    confirmModal,
    conversation,
    conversationsPage,
    conversations,
    dashboard,
    electron,
    ...elevioApiReducers,
    elevio,
    emailFlow,
    emailMessages,
    errors,
    flowLanguages,
    form: reduxFormReducer,
    holdMusic,
    jabra,
    knowledge,
    messengerSettings,
    nodes,
    nodeWidgetCustomization,
    notifications,
    offers,
    originalEmail,
    presence,
    presenceOverlay,
    search,
    settings,
    team,
    telephony,
    timeline,
    transferToAgent,
    transferToNumber,
    transferToQueue,
    twilio,
    typing,
    userModal,
    visibility,
    waitMusic,
    websocket,
    widget,
  });

  const rootReducer: Reducer<ReturnType<typeof reducer>, AnyAction> = (
    state,
    action,
  ) =>
    reducer(
      syncActions.state.match(action)
        ? ({ ...state, ...action.payload.state } as ReturnType<typeof reducer>)
        : state,
      action,
    );

  return rootReducer;
};
